// 企业账户模块 --- 提现
import request from '../request.js'
// 查询余额 --- 李开明
export const getBalance = function (data) {
    return request({
        url: 'bmPayment/selectBalance',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 查询收支明细 --- 李开明
export const getAccountDetail = function (data) {
    return request({
        url: 'bmPayment/selectAccountDetail',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

// 提现记录 --- 李开明(刘献根)
export const getWithDrawRecords = function (data) {
    return request({
        url: 'bmPayment/selectWithdrawRecord',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}


// 提现记录 --- 确认提现
export const doWithDraw = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateWithdrawBill/accountWithdraw',
        method: 'post',
        data
    })
}

// 获取企业资金账户信息 --- 叶凡
export const getAccountInfo = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateAccount/getMemberInfo',
        method: 'post',
        data
    })
}

// 获取企业资金账户各步骤状态 --- 叶凡
export const getRecordsState = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateAccount/getRecordStatus',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}

// 获取企业资金账户第一步：基础信息 --- 叶凡
export const getAccountBase = function (data) {
    return request({
        url: 'sysTenant/getBaseInfo',
        method: 'post',
        data
    })
}

// 保存资金账户第一步：基础信息 --- 叶凡
export const saveAccountBase = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateAccount/setEnterpriseInfo',
        method: 'post',
        data
    })
}

// 保存资金账户第二步：电子签约协议 --- 叶凡
export const doSign = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateAccount/signContractEx',
        method: 'post',
        data
    })
}

// 保存资金账户第三步：发送短信 --- 叶凡
export const sendMessage = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateAccount/sendMessage',
        method: 'post',
        data
    })
}

// 保存资金账户第三步：绑定手机 --- 叶凡
export const bindPhone = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateAccount/bindPhoneEx',
        method: 'post',
        data
    })
}

// 保存资金账户第四步：上传影像件 --- 叶凡
export const pictureCollect = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateAccount/pictureCollectEx',
        method: 'post',
        data
    })
}

// 查询各步骤当前状态 --- 叶凡
export const getStepState = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'applyRecord/getApplyStatus',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}

// 查询影像件当前状态 --- 叶凡
export const getPictureState = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'applyRecord/getPictureStatus',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}

// 查询通联所有状态 --- 叶凡
export const getAllState = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'applyRecord/updateRecordStatus',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}

// 获取支行列表（分页） --- 叶凡
export const getPageBanks = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateBank/getPageBanks',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}

// 分页条件查询账户 --- 李开明
export const selectAccountSubPage = function (data) {
    return request({
        url: 'bmPayment/selectAccountSubPage',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}

// 查询所有已开通企业账户的公司的账户 --- 李开明
export const selectCompanySub = function (data) {
    return request({
        url: 'bmPayment/selectAllCompanyAccountSub',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}

// 请求绑定银行卡 --- 李开明
export const bindBankCard = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateAccount/applyBindBankCard',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}

// 设置企业账户或个人账户是否开启 --- 李开明
export const setAccountSubStatus = function (data) {
    return request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: 'operateAccount/setAccountSubStatus',
        method: 'post',
        data,
        requestConfig: {
            hideLoading: true
        }
    })
}